<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/user"><span><i class="iconfont">&#xe703;</i>上传论文</span></router-link>
        </div>
        <div class="content" v-if="data.length">
            <p class="tips">*上传论文仅支持PC端上传</p>
            <div class="cards" v-for="item in data" :key="item.id">
                <p><span class="key">申请类型：</span><span class="value">{{item.type_id | dealName(metaList)}}</span></p>
                <p><span class="key">稿件题目：</span><span class="value">{{item.title}}</span></p>
                <p><span class="key">审核结果：</span><span class="value red">{{item.status | dealName(status)}}</span></p>
                <p><span class="key">论文作者：</span><span class="value">{{str2array(item.author)}}</span></p>
                <p><span class="key">论文摘要：</span><span class="value">{{item.summary}}</span></p>
                <p><span class="key">论文附件：</span><span class="value">{{item.file_name_list[0]}}</span></p>
            </div>
        </div>
        <div v-else class="no-data">
            <img src="~mpic/no-favorite.png">
            <p>暂无数据</p>
            <p class="tips">*上传论文仅支持PC端上传</p>
        </div>
    </div>
</template>

<script>
import { getPaperList,getMeta } from '../../../service'

export default {
    data(){
        return {
            height:0,
            metaList:[],
            data: [],
            status: [
              {id: '0', name: '待审核'},
              {id: '1', name: '已审核'},
              {id: '2', name: '作废'}
            ]
        }
    },
    computed: {
        user_key() {
            return this.$store.state.user_key
        }
    },
    methods:{
        async getList(){
            let res = await getPaperList({ user_key:this.user_key }, (error) => {this.$Message.error('请求错误!')})
            let meta_res = await getMeta({ name:['activity_material_type'] }, (error) => {this.$Message.error('请求错误!')})
            this.data = res.paper_list.map( (item) => {
                return item
            })
            this.metaList = meta_res.meta.activity_material_type
        },

        //转换论文作者
        str2array(str){
            if ( !typeof(str)=='string'){
                return '--'
            }
            let arr = JSON.parse(str)
            let names = ''
            arr.forEach(item => {
                names =names + item.name + ', ' + item.company + '; '
            });
            return names
        }
    },

    created(){
        this.getList()
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'

.content
    font-size: .28rem
    margin-bottom: .3rem;
    .tips
        padding: .3rem 0
        color:rgba(225,34,34,1);
    .cards
        line-height: .36rem
        padding: .27rem .35rem
        background: #ffffff
        border-radius: .1rem
        .key
            color: #999999
        .value
            color: #333333
            font-weight: bold
        .red
            color: #E12222
        p + p
            margin-top:.25rem
    .cards + .cards
        margin-top: .3rem
</style>
